export default __webpack_public_path__ + "static/media/Red Wings.6a019bb7.png";